import { trpc } from '@web/lib/trpc';

import { ContactAvatar } from './contact-avatar';

export function ContactOverview({ contactId }: { contactId: string }) {
  const { data: contactBasicInfo } = trpc.contact.getContactBasicInfo.useQuery({
    contactId,
  });

  return (
    <div className="min-h-40">
      {contactBasicInfo && (
        <>
          <ContactAvatar
            name={`${contactBasicInfo.firstName} ${contactBasicInfo.lastName}`}
            className="mx-auto size-20"
          />

          <h2 className="mb-6 mt-2 text-center text-xl font-bold">
            {contactBasicInfo.firstName} {contactBasicInfo.lastName}
          </h2>
        </>
      )}
    </div>
  );
}
